(() => {
  if (window.__homaPagesInit) return;
  window.__homaPagesInit = true;

  const all = (q, root = document) => Array.from(root.querySelectorAll(q));

  all('[data-faq-search]').forEach((input) => {
    const root = input.closest('.hp-section');
    if (!root) return;
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let shown = 0;
      all('.hp-faq details', root).forEach((row) => {
        row.hidden = query !== '' && !row.textContent.toLowerCase().includes(query);
        if (!row.hidden) shown += 1;
      });
      const count = root.querySelector('[data-search-count]');
      if (!count) return;
      count.textContent = shown
        ? shown + ' helpful answers'
        : 'No matching answers. Try a product, setup or order keyword, or use Contact Us.';
    });
  });

  document.querySelectorAll('.hp-section').forEach((root) => {
    const buttons = root.querySelectorAll('[data-filter]');
    if (!buttons.length) return;
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((other) => {
          other.setAttribute('aria-pressed', String(other === button));
        });
        const filter = button.dataset.filter;
        root.querySelectorAll('[data-tag]').forEach((card) => {
          card.hidden = filter !== 'All' && card.dataset.tag !== filter;
        });
      });
    });
  });

  const recommendations = {
    home: {
      title: 'Begin with one useful view.',
      body: 'Choose an entrance or space, then check power, network and the exact camera model. Consider placement and household access before adding another device.',
      href: '/pages/smart-home',
      label: 'Explore home awareness'
    },
    audio: {
      title: "Choose the room's role.",
      body: 'For shared interaction, compare Loom and Loom Mini. For television sound, check your display outputs and the exact soundbar connections. Start with the moment you want to create.',
      href: '/pages/audio-video',
      label: 'Explore audio & video'
    },
    personal: {
      title: 'Start with comfort and the task.',
      body: 'Consider personal listening, calls or focused work. Check the exact model, fit, permissions and current availability before choosing a personal device.',
      href: '/pages/smart-wearable',
      label: 'Explore personal experiences'
    },
    support: {
      title: 'Resolve the issue first.',
      body: 'Have the product model, purchase route and exact symptom ready. Begin with a clear support step before considering another purchase.',
      href: '/pages/help-center',
      label: 'Visit the Help Center'
    }
  };

  all('[data-guide-choice]').forEach((button) => {
    button.addEventListener('click', () => {
      const root = button.closest('.hp-section');
      const rec = recommendations[button.dataset.guideChoice];
      if (!root || !rec) return;
      all('[data-guide-choice]', root).forEach((other) => {
        other.setAttribute('aria-pressed', String(other === button));
      });
      const result = root.querySelector('[data-guide-result]');
      if (!result) return;
      result.hidden = false;
      result.replaceChildren();
      const heading = document.createElement('h3');
      const copy = document.createElement('p');
      const link = document.createElement('a');
      heading.textContent = rec.title;
      copy.textContent = rec.body;
      link.textContent = rec.label + ' \u2192';
      link.href = rec.href;
      link.className = 'hp-btn hp-btn-light';
      result.append(heading, copy, link);
    });
  });
})();
